export const dateFilter = (date) => {
  const parsedDate = new Date(date)
  return parsedDate.toLocaleDateString('es-ES', {
    day: 'numeric',
    year: 'numeric',
    month: 'short',
  })
}
